import { jsx as _jsx } from "react/jsx-runtime";
import { ModalHeader, SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import styled from 'styled-components';
import useSteps from '../../context/steps.context';
import CantVerify from '../../views/CantVerify';
import ModalFooter from '../../components/ModalFooter';
import { t } from '../../translations/getTranslation';
import ReasonSelection from '../../views/ReasonSelection';
import SelectAccount from '../../views/SelectAccount';
import { ReviewDamagedCard, ReviewMisplacedCard, ReviewNeverReceived } from '../../views/Review';
import Confirmation from '../../views/Confirmation';
import RecognizeTransactions from '../../views/RecognizeTransactions';
import CantProcess from '../../views/CantProcess';
import ExitConfirmation from '../../views/ExitConfirmation';
import CloseConfirmation from '../../views/CloseConfirmation';
import UnableSubmit from '../../views/UnableSubmit';
import APIError from '../../views/APIError';
import ErrorBoundary from '../../components/ErrorBoundary';
import ReasonSelectionLostCard from '../../views/ReasonSelectionLostCard';
import SelectCardholder from '../../views/SelectCardholder';
import WhenLost from '../../views/WhenLost';
import TempBlockWithNumber from '../../views/TempBlockWithNumber';
const stepViews = {
    ReasonSelection: _jsx(ReasonSelection, {}),
    SelectAccount: _jsx(SelectAccount, {}),
    SelectCardholder: _jsx(SelectCardholder, {}),
    ReviewDamagedCard: _jsx(ReviewDamagedCard, {}),
    ReviewMisplacedCard: _jsx(ReviewMisplacedCard, {}),
    ReviewNeverReceived: _jsx(ReviewNeverReceived, {}),
    RecognizeTransactions: _jsx(RecognizeTransactions, {}),
    Confirmation: _jsx(Confirmation, {}),
    CantVerify: _jsx(CantVerify, {}),
    CantProcess: _jsx(CantProcess, {}),
    CloseConfirmation: _jsx(CloseConfirmation, {}),
    ExitConfirmation: _jsx(ExitConfirmation, {}),
    UnableSubmit: _jsx(UnableSubmit, {}),
    APIError: _jsx(APIError, {}),
    ReasonSelectionLostCard: _jsx(ReasonSelectionLostCard, {}),
    WhenLost: _jsx(WhenLost, {}),
    TempBlockWithNumber: _jsx(TempBlockWithNumber, {})
};
export const flowTitleKeys = {
    replacement: 'common.replaceYourCard',
    'lost-stolen': 'common.lostOrStolen'
};
const Header = styled(ModalHeader) `
  & h1 {
    font-size: ${({ theme }) => theme.fontSizes.root}px;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    line-height: ${({ theme }) => theme.lineHeights.root};
  }
  & svg {
    font-size: ${({ theme }) => theme.fontSizes.large}px;
  }
`;
const StepView = ({ isOpen, portalId }) => {
    const { stepsState: { activeStep, flow }, stepsDispatch } = useSteps();
    const titleTextKey = flowTitleKeys[flow];
    const handleClose = () => {
        const skipCloseConfirmationSteps = [
            'Confirmation',
            'CantVerify',
            'CantProcess',
            'UnableSubmit',
            'APIError',
            'TempBlockWithNumber',
            'CloseConfirmation'
        ];
        if (skipCloseConfirmationSteps.includes(activeStep)) {
            stepsDispatch({ type: 'closeFlow' });
            return;
        }
        stepsDispatch({ type: 'confirmClose' });
    };
    return (_jsx(SlideInModalPortal, Object.assign({ isOpen: isOpen, id: "replacement-card-modal", escapeModalHandler: handleClose, containerId: portalId, header: _jsx(Header, { dataReason: "x button", dataType: flow === 'replacement' ? 'replacement card' : 'lost-stolen', content: t(titleTextKey), closeModal: handleClose }), footer: _jsx(ModalFooter, {}) }, { children: _jsx(ErrorBoundary, { children: stepViews[activeStep] }) })));
};
export default StepView;
//# sourceMappingURL=index.js.map